import { DragDropModule } from '@angular/cdk/drag-drop';
import { CommonModule } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialog, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { CombinedReadonlyDirective } from '../../../../../../../directives/combined-readonly.directive';
import { ActivityEditDialogData, ActivityFerryTicket } from '../../../../../../../models';
import { InputMonetaryAmountComponent } from '../../../../../../shared/input-monetary-amount/input-monetary-amount.component';
import { InputTimeComponent } from '../../../../../../shared/input-time/input-time.component';
import { FERRY_TICKET_DISCLAIMER_TEXT } from '../../../../../../shared/utils';
import { ActivityEditDialogBase } from '../../activity-edit-dialog-base';

@Component({
  selector: 'app-ferry-ticket-edit-dialog',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatButtonModule,
    DragDropModule,
    TranslateModule,
    InputTimeComponent,
    InputMonetaryAmountComponent,
    CombinedReadonlyDirective
  ],
  templateUrl: './ferry-ticket-edit-dialog.component.html'
})
export class FerryTicketEditDialogComponent extends ActivityEditDialogBase<ActivityFerryTicket> implements OnInit {

  form!: FormGroup;

  today: Date | null;

  constructor(
    dialogRef: MatDialogRef<FerryTicketEditDialogComponent>,
    confirmationDialog: MatDialog,
    translateService: TranslateService,
    @Inject(MAT_DIALOG_DATA) override data: ActivityEditDialogData
  ) {
    super(dialogRef, confirmationDialog, translateService, data);
    this.today = new Date();
    // in case of edit existing activity get the index of it
  }

  ngOnInit(): void {

    this.initForm();

    // ABBIAMO DECISO IL 19/10/2025 CHE LA DATA DI PAGAMENTO VIENE INSERITA NELLA DIALOG DAL TD
    // E VIENE IMPOSTATA COME DATA MINIMA LA DATA ODIERNA
    // la data di acquisto anticipato ha come limite massimo la start date
    // e viene prevalorizzata 30 gg prima di essa
    // const defaultAdvancePurchaseDate = new Date(this.today!);
    // defaultAdvancePurchaseDate.setDate(defaultAdvancePurchaseDate.getDate() - 30);
    // this.form.get('advancePurchaseDate')?.setValue(defaultAdvancePurchaseDate);

    if (this.data.activityData) {
      this.fillFormFields(this.data.activityData as ActivityFerryTicket);
    }

  }

  initForm(): void {
    this.form = new FormGroup({
      departurePort: new FormControl('', [Validators.required, Validators.maxLength(30)]),
      arrivalPort: new FormControl('', [Validators.required, Validators.maxLength(30)]),
      startTime: new FormControl('', [Validators.required]),
      endTime: new FormControl('', [Validators.required]),
      totalPrice: new FormControl(0, [Validators.required, Validators.min(0)]),
      advancePurchaseDays: new FormControl('', [Validators.required]),
      companyName: new FormControl(''),
      notes: new FormControl(''),
      disclaimer: new FormControl(FERRY_TICKET_DISCLAIMER_TEXT),
      name: new FormControl('Ferry Ticket'),
      type: new FormControl('ferry-ticket'),
    });
  }

  private fillFormFields(data: ActivityFerryTicket): void {
    this.form.patchValue({
      departurePort: data.departurePort,
      arrivalPort: data.arrivalPort,
      startTime: data.startTime,
      endTime: data.endTime,
      totalPrice: data.totalPrice,
      advancePurchaseDays: data.advancePurchaseDays,
      companyName: data.companyName,
      name: data.name,
      disclaimer: data.disclaimer,
      notes: data.notes
    })

  }

  confirm(): void {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }
    const activityData: ActivityFerryTicket = this.form.getRawValue() as ActivityFerryTicket;
    this.confirmAndCloseDialog(activityData);
  }

  cancel(): void {
    this.dialogRef.close();
  }

  /**
  * Get error message for label field
  */
  getLabelErrorMessage(fieldName: string): string {
    if (this.form.get(fieldName)?.hasError('required')) {
      return "required-field"
    }
    if (this.form.get(fieldName)?.hasError('maxlength')) {
      return "maxlenght-field";
    }
    return '';
  }

}